import request from '@app/utils/apiRequest';

export const requestSaveInviteJobMailTemp = (data) => request.post(`/mail/invite-job-mail-temp/save`, data)
export const requestGetInviteJobMailTemps = (params) => request.get(`/mail/invite-job-mail-temp/list`, {params: params});
export const requestGetInviteJobMailTempDetail = (params) => request.get(`/mail/invite-job-mail-temp/detail`, {params: params});

